/*
 * Tracking Event Editor - Event Unsaved Changes Warning Dialog
 * Controller: eventUnsavedChangesWarning
 */
import ngAnimateModule from "angular-animate";
import ngSanitizeModule from "angular-sanitize";
import uiBootstrapModule from "angular-ui-bootstrap";
import kendoDirectivesModule from "../../../shims/kendoDirectives";

import Assert from "tbAssert";



const mModalInstance = new WeakMap();

const userOverrideStatusMessage = "USEROVERRIDE";
const userCancelledStatusMessage = "USERCANCEL";

class EventUnsavedChangesWarningDialogController {
    constructor($uibModalInstance) {
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing UI Modal Instance Dependency");
        mModalInstance.set(this, $uibModalInstance);
    }

    $onInit() {
    }

    overrideWarnings() {
        mModalInstance.get(this).close(userOverrideStatusMessage);
    }

    cancelWorkflow() {
        mModalInstance.get(this).dismiss(userCancelledStatusMessage);
    }
}

EventUnsavedChangesWarningDialogController.UserOverrideStatusMessage = userOverrideStatusMessage;
EventUnsavedChangesWarningDialogController.UserCancelledStatusMessage = userCancelledStatusMessage;

EventUnsavedChangesWarningDialogController.$inject = [
    "$uibModalInstance"
];

EventUnsavedChangesWarningDialogController.dependencies = [
    ngAnimateModule,
    ngSanitizeModule,
    uiBootstrapModule,
    kendoDirectivesModule
];

EventUnsavedChangesWarningDialogController.template = require("./EventUnsavedChangesWarningDialog.tpl.html");

EventUnsavedChangesWarningDialogController.controllerAs = "eventUnsavedChangesWarning";

export default EventUnsavedChangesWarningDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/event-unsaved-changes-warning-dialog/EventUnsavedChangesWarningDialogController.js
// module id = Wirw
// module chunks = 1